import React from 'react'

const ContributorActionPanel = ({
  onDelete,
  onSubmit,
  isEditing,
  contributorID,
}) => {
  return (
    <div className="columns is-gapless">
      <div className="column has-text-right">
        {contributorID && (
          <button className="button is-danger" onClick={onDelete}>
            DELETE
          </button>
        )}{' '}
        <button
          className="button is-primary"
          onClick={onSubmit}
          type="submit"
          disabled={!isEditing}
        >
          SAVE
        </button>
      </div>
    </div>
  )
}

export default ContributorActionPanel



// WEBPACK FOOTER //
// ./src/components/templates/contributor-form/ContributorActionPanel.js